import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ThreatHunts from "@/pages/ThreatHunts";
import Heatmaps from "@/pages/Heatmaps";
import AuditGovernance from "@/pages/AuditGovernance";
import Incidents from "@/pages/Incidents";
import Pulse from "@/pages/Pulse";
import Mfa from "@/pages/Mfa";
import IntakeHull from "@/pages/IntakeHull";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/hunts" element={<ThreatHunts />} />
              <Route path="/heatmaps" element={<Heatmaps />} />
              <Route path="/incidents" element={<Incidents />} />
              <Route path="/audit" element={<AuditGovernance />} />
              <Route path="/pulse" element={<Pulse />} />
              <Route path="/intake" element={<IntakeHull />} />
              <Route path="/mfa" element={<Mfa />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
